var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasSize)?_c('g',{staticClass:"c-graph-frame"},[_c('rect',{staticClass:"c-graph-frame__rect",attrs:{"x":_vm.rect.x,"y":_vm.rect.y,"height":_vm.rect.h,"width":_vm.rect.w}}),(_vm.hasLine)?_c('line',{staticClass:"c-graph-frame__line",attrs:{"x1":_vm.line.x1,"x2":_vm.line.x2,"y1":_vm.line.y,"y2":_vm.line.y}}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }